import React from 'react';
import { ElevatedButton } from '@producer/ui-kit';

import styles from './crash-error-screen.module.scss';
export const CrashErrorScreen: React.FC = () => (
  <div className={styles['container']}>
    <div className={styles['wrapper']}>
      <p className={styles['text']}>
        There has been an error! Hit refresh to break the suspense and get back to working on your
        masterpiece.
      </p>

      <div className={styles['button-wrapper']}>
        <ElevatedButton text="Refresh page" onClick={() => window.location.reload()} isFullWidth />
      </div>
    </div>
  </div>
);
